// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"zu-z","categoryName":"Au-z","categoryImage":"Bu-z","categoryContent":"Cu-z","bottomAligned":"Du-z"};